const cashiers = {
  'cashier-header': 'Cashier',
  table: {
    no: 'No',
    reg: 'Patient Reg. No',
    patientName: 'Patient Name',
    registrationDate: 'Visit Date',
    billingPayment: 'Billing Payment',
    totalPrice: 'Total Price',
    totalPaid: 'Total Paid'
  },
  button: {
    exportDataCashier: 'Export Data Cashier',
    dataCashier: 'Data Cashier'
  },
  modal: {
    exportDataCashier: {
      header: 'Export Transaction Cashier',
      field: {
        rangeDate: 'Range Date'
      }
    }
  },
  billingTransaction: {
    headerInfo: {
      patientRegistrationNumber: 'Patient Registration No',
      mrNumber: 'MR Number',
      patientName: 'Patient Name',
      registrationNote: 'Registration Note'
    },
    tableBillingTransaction: {
      header: 'Billing Transaction',
      no: 'No',
      receiptNo: 'Receipt No',
      paymentDate: 'Payment Date',
      totalPrice: 'Total Price',
      converedAmount: 'Covered Amount',
      totalExcess: 'Total Excess',
      totalAmount: 'Total Amount',
      totalDiscount: 'Total Discount',
      action: {
        recalculate: 'Recalculate',
        billingPayment: 'Billing Payment'
      }
    },
    tableBillingAdjustment: {
      header: 'Billing Adjustment',
      ref: 'Reference Receipt No',
      total: 'Total Amount',
      gap: 'Amount Gap',
      remarks: 'Remarks',
      action: {
        excess: 'Excess',
        clear: 'Clear',
        billingAdjustment: 'Billing Adjustment'
      }
    },
    tableProductRegistration: {
      header: 'Product Registration',
      no: 'No',
      reg: 'Product Reg. No',
      registrationDate: 'Registration Date',
      totalPrice: 'Total Price',
      totalExcess: 'Total Excess',
      totalBilled: 'Total Amount Billed'
    },
    button: {
      billing: 'Billing',
      createBilling: 'Create Billing'
    },
    modal: {
      printItemDataCashier: {
        header: 'Print Item Data Cashier'
      },
      createBilling: {
        header: 'Confirm Create Billing',
        message: 'Are you sure want to create this billing payment?'
      },
      cancelBillingTransaction: {
        message: 'Are you sure want to cancel this billing transaction?'
      },
      manageExcess: {
        header: 'Manage Excess',
        totalPrice: 'Total Price',
        excessType: 'Excess Type',
        selectExcessType: 'Select Excess Type',
        percentage: 'Percentage',
        totalExcess: 'Total Excess'
      }
    }
  },
  billingPayment: {
    header: 'Billing Payment',
    productPriceInfo: {
      header: 'Product Price Info',
      tableTitle: 'Pricelist Detail',
      column: {
        no: 'No',
        product: 'Product',
        service: 'Service',
        price: 'Price',
        totalDiscount: 'Total Discount',
        totalPromo: 'Total Promo',
        totalPrice: 'Total Price',
        serviceDiscount: 'Service Discount',
        additionalDiscount: 'Additional Discount'
      }
    },
    historyTransaction: {
      header: 'History Transaction',
      button: {
        addPayment: 'Add Payment'
      },
      column: {
        no: 'No',
        paymentMethod: 'Payment Method'
      }
    },
    headerInfo: {
      receiptNo: 'Receipt No',
      registrationNumber: 'Registration Number',
      mrNumber: 'MR Number',
      patientName: 'Patient Name',
      registrationNote: 'Registration Note',
      subTotal: 'Sub Total',
      totalDiscount: 'Total Discount',
      totalPrice: 'Total Price',
      paidAmount: 'Paid Amount',
      unpaidAmount: 'Unpaid Amount',
      totalExcess: 'Total Excess',
      totalAmount: 'Total Amount'
    },
    button: {
      finishPayment: 'Finish Payment'
    },
    modal: {
      finishPayment: {
        header: 'Note Payment'
      },
      addPayment: {
        header: 'Payment Info',
        field: {
          unpaidAmount: 'Unpaid Amount',
          paymentMethod: 'Payment Method',
          totalPayment: 'Total Payment',
          change: 'Change',
          cardType: 'Card Type',
          bankName: 'Bank Name',
          otherBank: 'Other Bank',
          cardName: 'Card Name',
          cardNumber: 'Card Number',
          qrisName: 'QRIS Name',
          qrisNumber: 'QRIS Number',
          approvalCode: 'Approval Code',
          accountName: 'Account Name'
        }
      }
    }
  },
  billingAdjustment: {
    header: 'Billing Adjustment Payment',
    subHeader: 'Pricelist Detail',
    headerInfo: {
      uuid: 'UUID',
      refNo: 'Reference Receipt No',
      regNo: 'Registration Number',
      mrNumber: 'MR Number',
      patientName: 'Patient Name',
      registrationNote: 'Registration Note',
      subTotal: 'Sub Total',
      totalDiscount: 'Total Discount',
      totalPrice: 'Total Price',
      totalExcess: 'Total Excess',
      totalAmount: 'Total Amount',
      totalRef: 'Total Amount Reference Receipt',
      gap: 'Amount Gap',
      remarks: 'Remarks',
      note: 'Note'
    }
  }
}

export default cashiers
